module.exports = __webpack_public_path__ + "static/img/logo.1bb0749.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo.png
// module id = KItN
// module chunks = 1